<template>
  <el-form-item :label="i18nt('designer.setting.controlsPosition')">
    <el-select v-model="optionModel.controlsPosition">
      <el-option
        label="default"
        value=""
      />
      <el-option
        label="right"
        value="right"
      />
    </el-select>
  </el-form-item>
</template>

<script>
import i18n from '@/utils/i18n'

/* eslint-disable */
export default {
  name: 'ControlsPositionEditor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },

}
</script>

<style scoped>

</style>
